<template lang="pug">
  div.page--blog.page
    page-header(
      :breadcrumb-only="false"
      :page-title='trans("menus.frontend.navigation.articles")'
      page-title-class='col-12 text-center align-items-center'
      header-class="page-header--blog"
      header-background="/img/frontend/page/blog-header-default-background.jpg"
    )
    .container
      .row
        .col
          .featured-blog(v-if="featuredPost")
            .row.no-gutters.h-100
              .col-lg-7.h-100
                router-link.featured-blog__image-container(:to="{ name: 'blog.single', params: { slug: featuredPost.post_name } }")
                  img.featured-blog__image(:src='featuredPost.image', alt='')
              .col-lg-5
                .featured-blog__content
                  router-link(:to="{ name: 'blog.single', params: { slug: featuredPost.post_name } }")
                    h2.featured-blog__title {{ featuredPost.post_title }}
                  p.featured-blog__description {{ featuredPost.short_description }}
                  .featured-blog__author(v-if="featuredPost.user_data")
                    .row
                      .col-auto
                        .featured-blog__author-thumbnail
                          img(:src='featuredPost.user_avatar.full', alt='' v-if="featuredPost.user_avatar")
                      .col
                        .featured-blog__meta
                          p
                            | {{ trans('labels.frontend.blog.article_by') }}
                            span.ml-1 {{ featuredPost.user_data.display_name }}
                          p {{ trans('labels.frontend.blog.on') }} {{ featuredPost.post_date | moment('D/M/Y') }} {{ trans('labels.general.time') }} {{ featuredPost.post_date | moment('HH:mm') }}
    .container
      .row
        .col-12
          ul.blog-navigation.list-unstyled
            li.list-inline-item
              router-link(:to="{ name: 'blog.index' }") {{ trans('labels.general.all_alt') }}
            li.list-inline-item(v-for="category in categories")
              router-link(:to="{ name: 'blog.category.index', params: { slug: category.term.slug } }") {{ category.term.name }}
    .blog-list
      .container
        .row
          blog-item(v-for="post in posts" :post="post" :key="post.id")
        .row(v-if="options.pagination && options.pagination.last_page > 1")
          .col-12.text-center
            b-pagination.justify-content-center(
              v-if="options.pagination"
              v-model="options.pagination.current_page"
              :total-rows="options.pagination.total"
              :per-page="options.pagination.per_page"
              @change="onPageChange"
            )


</template>

<script>
import matchHeight from 'jquery-match-height';
import BreadcrumbsManager from '../../mixins/BreadcrumbsManager';
import BlogItem from './loop/BlogItem.vue';
import PageHeader from '../../components/layouts/PageHeader.vue';
import { RepositoryFactory } from '../../repositoryFactory';

window.matchHeight = matchHeight;

const BlogRepository = RepositoryFactory.get('blog');

export default {
  components: {
    BlogItem,
    PageHeader,
  },
  mixins: [BreadcrumbsManager],
  metaInfo() {
    return {
      title: Lang.get('menus.frontend.navigation.articles'),
    };
  },
  data() {
    return {
      categories: [],
      featuredPost: {},
      posts: [],
      options: {},
      filters: {},
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: window.Lang.get('menus.frontend.navigation.articles') },
    ]);
  },
  mounted() {
    this.getCategories();
    this.getFeaturedPosts();
    this.getPosts();

    this.$watch('filters', _.debounce(() => {
      this.getPosts();
    }, 300), { deep: true });
  },
  methods: {
    async getCategories() {
      const { data } = await BlogRepository.category().get({ lang: Lang.getLocale(), parent: 0 });
      this.categories = data;
    },
    async getFeaturedPosts() {
      const { data } = await BlogRepository.post().get({
        category_not_in: 'recommended-products', published: true, paginated: false, limit: 1, sort: 'post_date|desc',
      }).then((resp) => resp.data);
      this.$set(this, 'featuredPost', data[0]);
    },
    async getPosts() {
      const response = await BlogRepository.post().get({
        category_not_in: 'recommended-products', published: true, sort: 'post_date|desc', offset: 1, per_page: 16, ...this.filters,
      }).then((resp) => resp.data);
      this.posts = response.data;
      this.options = {
        ...this.options,
        ...{
          pagination: response.meta,
        },
      };

      Vue.nextTick(() => {
        $('.blog-list__item-body').matchHeight();
      });
    },
    onPageChange(page) {
      this.filters = { ...this.filters, ...{ page } };
    },
  },
};
</script>
